import React from 'react'
import {Editor} from 'draft-js'
import MessageUtils from '../../util/MessageUtils'
import './Editor.css'

const EditorUI = ({messageList, editorState, toggleBlockType, toggleInlineStyle, onClick, placeholderKey,
    handleKeyCommand, handleReturn, onChange, onTab, setDomEditorRef
  }) =>
  <div className="w_editor">
    <div className='controls'>
      <BlockStyleControls
        editorState={editorState}
        onToggle={toggleBlockType}
      />
      <InlineStyleControls
        editorState={editorState}
        onToggle={toggleInlineStyle}
      />
    </div>

    <div className='inner' onClick={onClick}>
      <Editor
        editorState={editorState}
        blockStyleFn={blockStyleFn}
        handleKeyCommand={handleKeyCommand}
        handleReturn={handleReturn}
        onChange={onChange}
        onTab={onTab}
        spellCheck={true}
        placeholder={placeholderKey ? MessageUtils.getMessageValue(messageList, placeholderKey) : null}
        ref={setDomEditorRef}
      />
    </div>
  </div>

function blockStyleFn(block) {
  switch (block.getType()) {
    case 'blockquote': return 'blockquote';
    default: return null;
  }
}

const BLOCK_TYPES = [
  /*
  {label: 'H1', style: 'header-one'},
  {label: 'H2', style: 'header-two'},
  {label: 'H3', style: 'header-three'},
  {label: 'H4', style: 'header-four'},
  {label: 'H5', style: 'header-five'},
  {label: 'H6', style: 'header-six'},
  {icon: 'icon-code', style: 'code-block'},
  */
  {icon: 'icon-header', style: 'header-three'},
  {icon: 'icon-list-ul', style: 'unordered-list-item'},
  {icon: 'icon-list-ol', style: 'ordered-list-item'},
  {icon: 'icon-quote-left', style: 'blockquote'},
];

const BlockStyleControls = (props) => {
  const {editorState} = props;
  const selection = editorState.getSelection();
  const blockType = editorState
    .getCurrentContent()
    .getBlockForKey(selection.getStartKey())
    .getType();

  return (
    <div className='group'>
      {BLOCK_TYPES.map((type, i) =>
        <StyleButton
          key={i}
          active={type.style === blockType}
          icon={type.icon}
          onToggle={props.onToggle}
          style={type.style}
        />
      )}
    </div>
  );
};

var INLINE_STYLES = [
  {icon: 'icon-bold', style: 'BOLD'},
  {icon: 'icon-italic', style: 'ITALIC'},
  {icon: 'icon-underline', style: 'UNDERLINE'},
  {icon: 'icon-code', style: 'CODE'},
];

const InlineStyleControls = (props) => {
  var currentStyle = props.editorState.getCurrentInlineStyle();
  return (
    <div className='group'>
      {INLINE_STYLES.map((type, i) =>
        <StyleButton
          key={i}
          active={currentStyle.has(type.style)}
          icon={type.icon}
          onToggle={props.onToggle}
          style={type.style}
        />
      )}
    </div>
  );
};

class StyleButton extends React.Component {
  constructor() {
    super();
    this.onToggle = (e) => {
      e.preventDefault();
      this.props.onToggle(this.props.style);
    };
  }

  render() {
    return (
      <span
        className={`icon ${this.props.icon} ${this.props.active ? 'active' : ''}`}
        onMouseDown={this.onToggle}>
        {this.props.label}
      </span>
    );
  }
}

export default EditorUI
